import * as betgalaxy from './Withdrawal.styles.betgalaxy';
import * as betprofessor from './Withdrawal.styles.betprofessor';
import * as betroyale from './Withdrawal.styles.betroyale';
import * as fiestabet from './Withdrawal.styles.fiestabet';
import * as goldenrush from './Withdrawal.styles.goldenrush';
import * as juicybet from './Withdrawal.styles.juicybet';
import * as puntcity from './Withdrawal.styles.puntcity';
import * as puntgenie from './Withdrawal.styles.puntgenie';
import * as questbet from './Withdrawal.styles.questbet';
import * as sterlingparker from './Withdrawal.styles.sterlingparker';
import * as vikingbet from './Withdrawal.styles.vikingbet';
import * as volcanobet from './Withdrawal.styles.volcanobet';
import * as wellbet from './Withdrawal.styles.wellbet';
import * as forsport from './Withdrawal.styles.forsport';
import * as junglebet from './Withdrawal.styles.junglebet';
import * as oldgill from './Withdrawal.styles.oldgill';
import * as sugarcastle from './Withdrawal.styles.sugarcastle';
import * as buffalobet from './Withdrawal.styles.buffalobet';
import * as titanbet from './Withdrawal.styles.titanbet';
import * as slambet from './Withdrawal.styles.slambet';
import * as gigabet from './Withdrawal.styles.gigabet';
import * as betstride from './Withdrawal.styles.betstride';
import * as templebet from './Withdrawal.styles.templebet';
import * as goldenbet888 from './Withdrawal.styles.goldenbet888';
import * as hyperbet from './Withdrawal.styles.hyperbet';
import * as bet777 from './Withdrawal.styles.bet777';
import * as chromabet from './Withdrawal.styles.chromabet';
import * as bet575 from './Withdrawal.styles.bet575';
import * as epicodds from './Withdrawal.styles.epicodds';
import * as pyramidbet from './Withdrawal.styles.pyramidbet';
import * as magnumbet from './Withdrawal.styles.magnumbet';
import { EThemesOG } from '@/constants/themeConfig';

export const styleImports: Partial<Record<EThemesOG, any>> = {
  betgalaxy,
  betprofessor,
  betroyale,
  fiestabet,
  goldenrush,
  juicybet,
  puntcity,
  puntgenie,
  questbet,
  sterlingparker,
  vikingbet,
  volcanobet,
  wellbet,
  forsport,
  junglebet,
  oldgill,
  sugarcastle,
  buffalobet,
  titanbet,
  slambet,
  gigabet,
  betstride,
  templebet,
  goldenbet888,
  hyperbet,
  bet777,
  chromabet,
  bet575,
  epicodds,
  pyramidbet,
  magnumbet,
};
